import React, { useEffect, useRef } from 'react';
import image1 from '../../assets/images/howItsWorks/11.png';
import image2 from '../../assets/images/howItsWorks/12.png';
import image3 from '../../assets/images/howItsWorks/expertesInfo.png';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      image: image1,
      heading: "Share Your Needs",
      description: "It all starts with a conversation. Tell us what issues are you facing? Whether you are looking for managing Anxiety Treatment near me, navigating Relationship Counseling near me, or seeking help with PTSD or Depression. This is your judgment-free space to share. Based on what you provide, we’ll match you with a certified counselor who understands your unique situation.",
      descriptionPhone:"Your journey starts with a conversation. Share your concerns, and we’ll connect you with the right expert for support."

    },
    {
      id: 2,
      image: image2,
      heading: "Expert Match Made Easy",
      description: "We introduce you to one of our licensed mental health professionals specializing in counselling for Depression and Anxiety, PTSD treatment near me, or Family Constellation Therapy near me. The best part? You pick the time that works for you, without waiting weeks or fitting into rigid schedules. We make scheduling your online CBT Therapy or affordable counseling easy and convenient",
      descriptionPhone:"Next, we’ll connect you with a licensed professional. Pick a time that works for you and take the next step toward healing."
    },
    {
      id: 3,
      image: image3,
      heading: "Confidential, Personalized Support",
      description: "Your session takes place over a secure, confidential platform. Whether you prefer video calls or chat, your therapist will provide professional counseling tailored to your needs be it CBT and DBT therapy, online therapy for Depression, or Relationship Counselling online. Each session is designed to help you feel heard, supported, and equipped with practical strategies for your Mental Wellness Journey",
      descriptionPhone:"When it’s time, connect securely via video or chat. Each session is tailored to you, leaving you heard, empowered, and prepared."

    }
  ];

  // Add animation for elements when they come into view
  const textRefs = useRef([]);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      { threshold: 0.1 }
    );

    // Store current refs in a variable that will be captured in the closure
    const currentRefs = textRefs.current;
    
    currentRefs.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    // Use the captured variable in the cleanup function
    return () => {
      currentRefs.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <div>
      <div className="container-hiw">
        <h2 className="heading-xl">How it works</h2>
        
        {steps.map((step, index) => (
          <div key={index}>
            <div className="step-container">
              <div 
                className="text-container-hiw"
                ref={(el) => (textRefs.current[index] = el)}
              >
                <img className='img-hiw1' src={step.image} alt={`Step ${index + 1}`} />

                <div className="description-hiw">
                  <h2 className="heading-lg">{step.heading}</h2>
                  <p className="paragraph-piw">{step.description}</p>
                  <p className="paragraph-piw-phone">{step.descriptionPhone}</p>
                </div>
              </div>
            </div>
            
            {index < steps.length - 1 && (
              <div className="hiw-arrow-container">
                <div className="hiw-arrow-wrapper">
                  <div className="hiw-arrow"></div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;